<!-- Modal Customer -->
<div bsModal #customerModal="bs-modal" class="modal fade" tabindex="-1" [config]="{backdrop: 'static'}"
     role="dialog" aria-labelledby="dialog-sizes-name1">
    <form id="customerForm" appPromptUnsubmitted (ngSubmit)="save()">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 id="dialog-nested-name1" class="modal-title pull-left">Add new customer</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="form-group col-12">
                            <label for="name">Name</label>
                            <input class="form-control"
                                   id="name"
                                   [(ngModel)]="customer.name"
                                   name="name"
                                   type="text"
                                   [appIsInvalid]="!customer.name"
                                   required>
                            <div class="invalid-feedback">
                                Name is Required.
                            </div>
                        </div>
                        <div class="form-group col-12">
                            <label>Country</label>
                            <div class="autocomplete">
                                <input [typeahead]="countries"
                                       [typeaheadMinLength]="0"
                                       [(ngModel)]="customer.country"
                                       [appIsInvalid]="!customer.country"
                                       name="country"
                                       class="form-control"
                                       required>
                                <div class="invalid-feedback">
                                    Country is Required.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-12">
                            <label>Customer Type</label>
                            <select class="form-control custom-select"
                                    [(ngModel)]="customer.customerType"
                                    id="ccyear"
                                    name="customerType"
                                    [appIsInvalid]="!customer.customerType" required>
                                <option [ngValue]="1">B2B</option>
                                <option [ngValue]="2">B2C</option>
                            </select>
                            <div class="invalid-feedback">
                                Customer Type is Required.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-primary" aria-label="Close" type="submit" form="customerForm">
                        Add new
                    </button>
                    <button type="button"
                            class="btn btn-outline-dark"
                            data-dismiss="modal"
                            aria-label="Close"
                            (click)="cancel()">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>

<app-duplicate-name-confirm-modal #confirmDuplicateName></app-duplicate-name-confirm-modal>
